import { useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import RemoveIcon from "@material-ui/icons/Remove";
import { Container, Snackbar } from "@material-ui/core";
import {
  AppBar,
  Toolbar,
  Table,
  TableRow,
  TableBody,
  TableCell,
} from "@material-ui/core";
import Expand from "react-expand-animated";
import { get, uniqueId } from "lodash";
import ReactHtmlParser from "react-html-parser";
import MuiAlert from "@material-ui/lab/Alert";

import { journeyStore } from "../../../stores/journey-store";
import { maxTabletScreenWidth } from "../../../services/constants";
import "./AppointmentCard.scss";
import { getHighlightTextSearchMarkup } from "../../../helpers/highlighterHelpers";

const hasNumber = (myString) => {
  return /\d/.test(myString);
};

const retNumber = (myString) => {
  let num = myString.replace(/[^0-9]/g, "");
  return parseInt(num, 10);
};

export const AppointmentCardDetails = ({
  title,
  description,
  can_book_from_portal,
  virtual,
  bullets,
  handleClose,
  event,
  group_class,
  searchText,
}) => {
  const [isExpandedBullet, setIsExpandedBullet] = useState(false);
  const [rowInTable, setRowInTable] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const isNotEventOrGroup = !event && !group_class;

  const selectedTitle = hasNumber(title)
    ? `${
        title.toLowerCase().includes("postpartum") ? "POSTPARTUM" : ""
      } WEEK ${retNumber(title)} APPOINTMENT`
    : title;

  const highlightedTitleText = getHighlightTextSearchMarkup(
    selectedTitle,
    searchText
  );

  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setResponseError(null);
  };

  return (
    <Container maxWidth="sm" className="appointment-container">
      <AppBar>
        <Toolbar>
          {window.innerWidth < maxTabletScreenWidth && (
            <ArrowBackIosIcon
              edge="start"
              color="inherit"
              onClick={() =>
                handleClose
                  ? handleClose()
                  : (journeyStore.appointmentCardToShow = undefined)
              }
              aria-label="close"
            >
              <CloseIcon />
            </ArrowBackIosIcon>
          )}
          <div className="dialog-title">APPOINTMENT</div>
        </Toolbar>
      </AppBar>
      <div className="dialog-body">
        <div className="appointment-title">
          <img
            className="icon"
            src="/icons/calendar@0,5x.svg"
            alt="calendar-icon"
          />
          {ReactHtmlParser(highlightedTitleText)}
        </div>

        {virtual && can_book_from_portal && isNotEventOrGroup && (
          <div>
            <div className="virtual-label">Virtual</div>
          </div>
        )}

        {event && (
          <div style={{ marginBottom: "10px" }}>
            <span className="event-label">Event</span>
          </div>
        )}

        {group_class && (
          <div style={{ marginBottom: "10px" }}>
            <span className="group-class-label">Group Class</span>
          </div>
        )}

        {!virtual && can_book_from_portal && isNotEventOrGroup && (
          <div style={{ marginBottom: "10px" }}>
            <div className="office-visit-label">Office Visit</div>
          </div>
        )}

        <div className="dialog-description">
          {description.map((section) => {
            if (get(section, "paragraph")) {
              const higlightedText = getHighlightTextSearchMarkup(
                section.paragraph,
                searchText
              );

              return <p key={uniqueId()}>{ReactHtmlParser(higlightedText)}</p>;
            }
            if (get(section, "list")) {
              const higlightedText = getHighlightTextSearchMarkup(
                section.list.title,
                searchText
              );
              return (
                <div className="appointment-list">
                  <p className="appointment-list-title">
                    {ReactHtmlParser(higlightedText)}
                  </p>
                  <ul>
                    {section.list.items.map((item) => {
                      const higlightedText = getHighlightTextSearchMarkup(
                        item,
                        searchText
                      );
                      return (
                        <li key={uniqueId()}>
                          {ReactHtmlParser(higlightedText)}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            }
          })}
        </div>
        {bullets && (
          <Table
            className="appointment-details-table"
            aria-label="simple table"
          >
            <TableBody>
              {bullets?.map((bullet, index) => {
                return (
                  <TableRow
                    onClick={() => {
                      if (rowInTable === index) {
                        setIsExpandedBullet(!isExpandedBullet);
                      } else {
                        setIsExpandedBullet(true);
                      }
                      setRowInTable(index);
                    }}
                  >
                    <TableCell component="th" scope="row">
                      <div className="table-title">{bullet.name}</div>
                      <Expand open={rowInTable === index && isExpandedBullet}>
                        <div className="table-subtitle">
                          {ReactHtmlParser(bullet.description)}
                        </div>
                      </Expand>
                    </TableCell>
                    <TableCell className="table-sign" align="right">
                      {rowInTable === index && isExpandedBullet ? (
                        <RemoveIcon />
                      ) : (
                        <AddIcon />
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </div>

      <Snackbar
        open={responseError}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity="error">
          {responseError}
        </Alert>
      </Snackbar>
    </Container>
  );
};
